export default {
  GLASS: "glass",
  DEVICES: "devices",
  REGULAR: "regular",
}